import { useState } from 'react';
import { fmtClock } from '../lib/format.js';

// CJ 2026-05-21: Schedule acceptance modal. Renders on login if the staff
// member has any published-but-unaccepted upcoming weeks. Lists the
// shifts so they review before tapping Accept. Modal can't be dismissed
// without accepting (or scrolling away on the underlying Dashboard) —
// CJ wants explicit acknowledgement.
export function ScheduleAcceptModal({ pending, onAccept }) {
  const [busy, setBusy] = useState(null); // `${locId}|${weekStart}`
  function fmtClock(t) {
    if (!t) return '';
    const [hh, mm] = String(t).slice(0, 5).split(':').map(Number);
    if (Number.isNaN(hh)) return t;
    const ampm = hh < 12 ? 'am' : 'pm';
    const h12 = ((hh + 11) % 12) + 1;
    return mm === 0 ? `${h12}${ampm}` : `${h12}:${String(mm).padStart(2, '0')}${ampm}`;
  }
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(28,31,29,0.55)', zIndex: 9999,
                    display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
                    padding: 16, overflowY: 'auto' }}>
      <div style={{ background: '#fff', borderRadius: 12, padding: 18, maxWidth: 520, width: '100%',
                      margin: '40px 0', boxShadow: '0 12px 48px rgba(0,0,0,0.25)' }}>
        <div style={{ fontSize: 18, fontWeight: 800, marginBottom: 4 }}>
          📅 Please review your schedule
        </div>
        <div style={{ fontSize: 13, color: '#555', marginBottom: 14 }}>
          {pending.length === 1
            ? "Your manager just published this week's shifts. Confirm you've seen them by tapping Accept."
            : `Your manager just published ${pending.length} weeks of shifts. Confirm you've seen each one.`}
        </div>
        {pending.map(p => {
          const key = `${p.location_id}|${p.week_start}`;
          const we = new Date(p.week_start + 'T12:00:00');
          we.setDate(we.getDate() + 6);
          const weekEndStr = we.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
          const weekStartStr = new Date(p.week_start + 'T12:00:00')
            .toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
          return (
            <div key={key} style={{ border: '1px solid #e0e0e0', borderRadius: 8, padding: 12, marginBottom: 10 }}>
              <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 6 }}>
                {p.location_name} · {weekStartStr} – {weekEndStr}
              </div>
              {(!p.shifts || p.shifts.length === 0) ? (
                <div style={{ fontSize: 12, color: '#888', fontStyle: 'italic' }}>No shifts this week.</div>
              ) : (
                <div style={{ fontSize: 13, color: '#212121', display: 'flex', flexDirection: 'column', gap: 4 }}>
                  {p.shifts.map(s => {
                    const d = new Date(s.shift_date + 'T12:00:00');
                    const day = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
                    return (
                      <div key={s.id}>
                        <strong>{day}:</strong> {fmtClock(s.start_time)}–{fmtClock(s.end_time)}
                        {s.role && <span style={{ color: '#757575' }}> · {s.role}</span>}
                      </div>
                    );
                  })}
                </div>
              )}
              <button onClick={async () => {
                  setBusy(key);
                  await onAccept(p.location_id, p.week_start);
                  setBusy(null);
                }}
                disabled={busy === key}
                style={{ marginTop: 10, width: '100%', padding: '10px 14px',
                          background: '#2e7d32', color: '#fff', border: 0, borderRadius: 8,
                          fontWeight: 700, fontSize: 14, cursor: 'pointer',
                          opacity: busy === key ? 0.6 : 1 }}>
                {busy === key ? 'Accepting…' : '✓ I have reviewed and accept'}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
